import { faCog, faUserAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Dropdown, Button } from 'reactstrap';
import DateDisplay from '../DateDisplay/DateDisplay';
import styled from 'styled-components';
import { openUrlInNewTabOrDetectBlock, urlWithHttpProtocol } from '../../../../Common.functions';
import Style from './UserInformation.style';
import Swal from 'sweetalert2';
import { truncate } from 'Services/candidates';
import NotificationTest from 'Body/RezRATE/Common/NotificationTest/NotificationTest';
import ThemeToggle from 'theme/ThemeToggle';

const CustomDropdown = styled(Dropdown)`
  button {
    background-color: transparent !important;
    border: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    text-align: left !important;
  }
`;

const REZRATE_VIDEO_WINDOW_TARGET = 'rezrate-video';

const isUsableNamePart = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const trimmedValue = value.trim();
  return trimmedValue !== '' && trimmedValue.toLowerCase() !== 'undefined' && trimmedValue.toLowerCase() !== 'null';
};

export const getDisplayName = (userInfo) => {
  const { UserFirst, UserLast } = userInfo || {};

  return [UserFirst, UserLast]
    .filter(isUsableNamePart)
    .map((value) => value.trim())
    .join(' ');
};

const UserInformation = (props) => {
  const [password, setPassword] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [logOut, setLogout] = useState(false);

  const { userInfo, isMobile, logoutClick, dContext, date, seasonType, dateArray, setDate } = props;
  const {
    UserPhotoUrl,
  } = userInfo || {};

  useEffect(() => {
    // console.log('props: ', props);
  }, [props]);

  const toggle = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  const getPasswordFromUrl = (zoomUrl) => {
    const passwordSplit = zoomUrl.split('?');
    if (passwordSplit[1]) {
      const withoutKey = passwordSplit[1].split('=');
      if (withoutKey[1]) {
        setPassword(withoutKey[1]);
      }
    }
  };

  const openAllDayRoomInNamedVideoWindow = () => {
    const formatted = urlWithHttpProtocol(date?.allDayRoom);
    const opened = openUrlInNewTabOrDetectBlock(formatted, REZRATE_VIDEO_WINDOW_TARGET);
    if (!opened) {
      Swal.fire('Error!', 'Please allow RezRATE to open the meeting window.', 'error');
    }
  };

  const renderAvatar = () => {
    if (UserPhotoUrl && UserPhotoUrl.trim() !== '') {
      return <img src={UserPhotoUrl} alt="avatar" />;
    }
    return <FontAwesomeIcon icon={faUserAlt} style={{ fontSize: 40, color: 'white' }} />;
  };

  const displayName = getDisplayName(userInfo);

  if (logOut) {
    return <Redirect to="/" />;
  }

  const renderDisplayName = (compact = false) => {
    return (
      <div
        data-testid="evaluator-display-name"
        aria-hidden={displayName ? undefined : true}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          minWidth: 0,
          minHeight: '1.2em',
          fontSize: compact ? 14 : 15,
          fontWeight: 'bold',
          color: 'white',
        }}
      >
        {displayName ? truncate(displayName, 35) : ''}
      </div>
    );
  };

  const renderSessionControls = (compact = false) => {
    const actionSlotWidth = compact ? 50 : 40;
    const actionRailWidth = compact ? actionSlotWidth : actionSlotWidth * 2;
    const dateControlMinWidth = compact ? 170 : 220;
    const compactActionButtonStyle = compact ? { width: 55, minWidth: 55, maxWidth: 55 } : undefined;
    const actionSlotStyle = {
      flex: `0 0 ${actionSlotWidth}px`,
      width: actionSlotWidth,
      minWidth: actionSlotWidth,
      boxSizing: 'border-box',
      paddingLeft: 10,
      display: 'flex',
      flexDirection: 'column',
    };
    const actionRailStyle = {
      display: 'flex',
      flex: `0 0 ${actionRailWidth}px`,
      width: actionRailWidth,
      minWidth: actionRailWidth,
    };
    const primaryControlStyle = {
      flex: `1 1 ${dateControlMinWidth}px`,
      minWidth: dateControlMinWidth,
      display: 'flex',
      flexDirection: 'column',
    };

    return (
      <div data-testid="evaluator-session-controls" style={{ display: 'flex', flexDirection: 'column', minWidth: 0, width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', minWidth: 0, width: '100%' }}>
          <div style={primaryControlStyle}>
            <DateDisplay
              date={date}
              seasonType={seasonType}
              season={dContext.season}
              dateArray={dateArray}
              setDate={setDate}
            />
          </div>
          <div style={actionRailStyle}>
            {!compact ? <div style={actionSlotStyle}><ThemeToggle style={{ width: 'var(--rr-control-sm)', height: 'var(--rr-control-sm)' }} /></div> : null}
            <div style={actionSlotStyle}>
              <Button
                id="logout_button"
                color="danger"
                size="sm"
                style={compactActionButtonStyle}
                onClick={(e) => {
                  e.preventDefault();
                  logoutClick();
                }}
              >
                <div>
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </div>
              </Button>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', minWidth: 0, width: '100%', marginTop: 5 }}>
          <div style={primaryControlStyle}>
            <Button
              size="sm"
              style={{ width: '100%' }}
              color={date && date.allDayRoom ? 'warning' : 'secondary'}
              onClick={() => {
                if (date?.allDayRoom) {
                  openAllDayRoomInNamedVideoWindow();
                } else {
                  Swal.fire({
                    title: 'No Break Room',
                    text: 'There is no break room for this date.',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                  });
                }
              }}
            >
              {date && date.allDayRoom ? 'Visit Break Room' : 'No break room configured'}
            </Button>
          </div>
          <div style={actionRailStyle}>
            {!compact ? <div style={actionSlotStyle} aria-hidden="true" /> : null}
            <div style={actionSlotStyle}>
              <NotificationTest
                size="sm"
                buttonStyle={compactActionButtonStyle}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDesktop = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', minWidth: 0, paddingBottom: 5 }}>
        <div style={{ display: 'flex', flex: '0 0 90px', width: 90, minWidth: 90, flexDirection: 'column', justifyContent: 'flex-end' }}>
          {renderAvatar()}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 0', minWidth: 0, marginLeft: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', width: '100%', marginTop: 10 }}>
            {renderDisplayName()}
          </div>
          {renderSessionControls()}
        </div>
      </div>
    );
  };

  const renderMobile = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0 }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 0, marginBottom: 5 }}>
          <div style={{ display: 'flex', flex: '0 0 40px', width: 40, minWidth: 40, flexDirection: 'column', justifyContent: 'center' }}>
            {renderAvatar()}
          </div>
          <div style={{ display: 'flex', flex: '1 1 0', minWidth: 0, marginLeft: 10 }}>
            {renderDisplayName(true)}
          </div>
        </div>
        {renderSessionControls(true)}
      </div>
    );
  };

  if (isMobile) {
    return renderMobile();
  } else {
    return renderDesktop();
  }
};

export default UserInformation;
